import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from '../../../base/services/toast.service';
import {
  ServiceClientClient,
  FilterDTO,
  SortDirection,
} from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';

@Injectable()
export class ServiceClientsAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private serviceClientClient: ServiceClientClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.serviceClientClient.searchServiceClients(skip, take, sortBy, sortDirection, filters)
      .pipe(
        map(result => ({
          items: result?.items ?? [],
          totalNumberOfItems: result?.totalNumberOfItems ?? 0
        } as IPagedItems)),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: any): Observable<any> {
    // Service clients are read-only
    return throwError(() => new Error('Service clients are read-only'));
  }

  public addRecord(data: any): Observable<any> {
    // Service clients cannot be added from here
    return throwError(() => new Error('Service clients cannot be added'));
  }

  public deleteRecord(id: number): Observable<any> {
    // Service clients cannot be deleted from here
    return throwError(() => new Error('Service clients cannot be deleted'));
  }
}
